<asw-goshokai-net-login-pres [params]="params"></asw-goshokai-net-login-pres>
